export default __webpack_public_path__ + "static/media/devOps.3d74db61.svg";